import toast from 'react-hot-toast';

const notifySuccess = (msg) => toast.success(msg);

const notifyError = (msg) => toast.error(msg)

export {
    notifyError,
    notifySuccess
};